export enum RequestStatus {
  pending = 'pending',
  accepted = 'accepted',
  rejected = 'rejected',
  revoked = 'revoked',
  sending = 'sending',
  failed = 'failed',
  sent = 'sent',
}
